class CommercialFileStatusEnum {

    static readonly ATTENTE_DE_FACTURE = new CommercialFileStatusEnum('ATTENTE_DE_FACTURE', 'En attente de Facture', 'attente_de_facture_badge', [], '', null); // TODO à vérifier
    static readonly FACTURE_RECU = new CommercialFileStatusEnum('FACTURE_RECU', 'Facture reçue', 'facture_recu_badge', [], '', null); // TODO à vérifier
    static readonly CONTRAT_PRO = new CommercialFileStatusEnum('CONTRAT_PRO', 'Contrat PRO', 'contrat_pro_badge', [], '', null); // TODO à vérifier
    static readonly CONTRAT_COTA = new CommercialFileStatusEnum('CONTRAT_COTA', 'Contrat COTA', 'contrat_cota_badge', [], '', null); // TODO à vérifier
    static readonly REGIE = new CommercialFileStatusEnum('REGIE', 'Régie', 'regie_badge', [], '', null); // TODO à vérifier
    static readonly VENTE = new CommercialFileStatusEnum('VENTE', 'Vente', 'vente_badge', [], '', null); // TODO à vérifier
    static readonly NRP = new CommercialFileStatusEnum('NRP', 'NRP', 'nrp_badge', [], '', null); // TODO à vérifier
    // CALO
    static readonly ENGAGE = new CommercialFileStatusEnum('ENGAGE', 'Engagé', 'engage_badge', [], 'CALO', '#800080');
    static readonly PAS_DE_RETOUR = new CommercialFileStatusEnum('PAS_DE_RETOUR', 'Pas de retour', 'default_badge', [], 'CALO', '#59afcc'); // TODO à vérifier
    static readonly FIN_TRAVAUX = new CommercialFileStatusEnum('FIN_TRAVAUX', 'Fin de travaux', 'default_badge', [], 'CALO', '#000080');
    static readonly DEBUT_TRAVAUX = new CommercialFileStatusEnum('DEBUT_TRAVAUX', 'Début de travaux', 'default_badge', [CommercialFileStatusEnum.FIN_TRAVAUX], 'CALO', '#6d6dff');

    static readonly REFUS = new CommercialFileStatusEnum('REFUS', 'Refus', 'refus_badge', [], 'CALO', '#FF0000');
    static readonly DEVIS_SIGNE = new CommercialFileStatusEnum('DEVIS_SIGNE', 'Devis signé', 'default_badge', [CommercialFileStatusEnum.DEBUT_TRAVAUX], 'CALO', '#00FFFF');
    // static readonly DEVIS_ET_CB_EDITE = new CommercialFileStatusEnum('DEVIS_ET_CB_EDITE', 'default_badge');
    static readonly ATTENTE_SIGNATURE_DEVIS = new CommercialFileStatusEnum('ATTENTE_SIGNATURE_DEVIS', 'En attente de signature de devis', 'attente_siganture_devis_badge', [CommercialFileStatusEnum.DEVIS_SIGNE, CommercialFileStatusEnum.REFUS], 'CALO', '#90de03');
    static readonly EN_CHIFFRAGE = new CommercialFileStatusEnum('EN_CHIFFRAGE', 'En chiffrage', 'chiffrage_badge', [CommercialFileStatusEnum.ATTENTE_SIGNATURE_DEVIS, CommercialFileStatusEnum.DEVIS_SIGNE, CommercialFileStatusEnum.REFUS], 'CALO', '#FFC300');
    static readonly PAS_INTERESSANT = new CommercialFileStatusEnum('PAS_INTERESSANT', 'Pas intéressant', 'default_badge', [], 'CALO', '#59afcc');
    static readonly RDV_A_REPLACER = new CommercialFileStatusEnum('RDV_A_REPLACER', 'Rendez-vous à replacer', 'default_badge', [], 'CALO', '#59afcc'); // nextStatus should be empty
    static readonly RDV = new CommercialFileStatusEnum('RDV', 'Rendez-vous', 'rdv_badge', [CommercialFileStatusEnum.RDV_A_REPLACER, CommercialFileStatusEnum.EN_CHIFFRAGE, CommercialFileStatusEnum.PAS_INTERESSANT, CommercialFileStatusEnum.REFUS], 'CALO', '#06ce06');
    static readonly RDV_TEL = new CommercialFileStatusEnum('RDV_TEL', 'Rendez-vous Tel', 'rdv_badge', [CommercialFileStatusEnum.RDV_A_REPLACER, CommercialFileStatusEnum.EN_CHIFFRAGE, CommercialFileStatusEnum.PAS_INTERESSANT, CommercialFileStatusEnum.REFUS], 'CALO', '#ff17c5');
    static readonly RAPPEL = new CommercialFileStatusEnum('RAPPEL', 'Rappel', 'rappel_badge', [CommercialFileStatusEnum.RDV, CommercialFileStatusEnum.REFUS, CommercialFileStatusEnum.ENGAGE], 'CALO', '#ecec3c');


    private constructor(
        /**
         * The name of the instance; should be exactly the variable name,
         * for serializing/deserializing simplicity.
         */
        public readonly name: string,
        public readonly label: string,
        public readonly badge: string,
        public readonly nextStatuses: CommercialFileStatusEnum[],
        public readonly type: string,
        public readonly color: string) {

        this.name = name;
        this.label = label;
        this.badge = badge;
        this.type = type;
        this.color = color;
        this.nextStatuses = nextStatuses;
    }

    static get values(): CommercialFileStatusEnum[] {
        return [
            this.RDV,
            this.RDV_TEL,
            this.RAPPEL,
            this.RDV_A_REPLACER,
            this.ATTENTE_DE_FACTURE,
            this.FACTURE_RECU,
            this.CONTRAT_PRO,
            this.CONTRAT_COTA,
            this.ENGAGE,
            this.REGIE,
            this.PAS_INTERESSANT,
            this.REFUS,
            this.VENTE,
            this.NRP,

            this.PAS_DE_RETOUR,
            this.EN_CHIFFRAGE,
            // this.DEVIS_ET_CB_EDITE,
            this.DEVIS_SIGNE,
            this.ATTENTE_SIGNATURE_DEVIS,
            this.DEBUT_TRAVAUX,
            this.FIN_TRAVAUX
        ];
    }

    static getListLabes(): CommercialFileStatusEnum[] {
        return [
            this.RDV,
            this.RDV_TEL,
            this.RAPPEL,
            this.RDV_A_REPLACER,
            this.ATTENTE_DE_FACTURE,
            this.FACTURE_RECU,
            this.CONTRAT_PRO,
            this.CONTRAT_COTA,
            this.ENGAGE,
            this.REGIE,
            this.REFUS,
            this.PAS_INTERESSANT,
            this.VENTE,
            this.NRP,

            this.PAS_DE_RETOUR,
            this.EN_CHIFFRAGE,
            // this.DEVIS_ET_CB_EDITE,
            this.ATTENTE_SIGNATURE_DEVIS,
            this.DEVIS_SIGNE,
            this.DEBUT_TRAVAUX,
            this.FIN_TRAVAUX
        ];
    }

    /**
     * Converts a string to its corresponding Status instance.
     *
     * @param string the string to convert to Status
     * @throws RangeError, if a string that has no corresponding Status value was passed.
     * @returns the matching Status
     */
    static fromString(string: string): CommercialFileStatusEnum {
        // Works assuming the name property of the status is identical to the variable's name.
        // Alternatively, you can search the .values array
        const value = (this as any)[string];
        if (value) {
            return value;
        }
        return null;
        //throw new RangeError(`Illegal argument passed to fromString(): $ {string} does not correspond to any instance of the enum ${(this as any).prototype.constructor.name}`);
    }

    /**
     * Called when converting the Enum value to a string using JSON.Stringify.
     * Compare to the fromString() method, which deserializes the object.
     */
    public getName(): string {
        return this.name;
    }

    public getLabel(): string {
        return this.label;
    }

    public getNextStatuses(): CommercialFileStatusEnum[] {
        return this.nextStatuses;
    }

    public getBadge(): string {
        return this.badge;
    }
}

export default CommercialFileStatusEnum;
